import React, {FC, useState} from "react"
import {
    Card,
    Col,
    Container,
    Row,
} from "react-bootstrap"
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Colors,
    Legend,
    LinearScale,
    Title as ChartTitle,
    Tooltip as ChartTooltip,
} from "chart.js"
import {Bar} from "react-chartjs-2"
import axios from "axios"
import {useAuth} from "../../context/AuthProvider"
import moment from "moment/moment"
import ChartDataLabels from "chartjs-plugin-datalabels"
import {useTheme} from "../../context/ThemeProvider"
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next"

type BookingDistributionComponentProps = Record<string, unknown>

const BookingDistributionComponent: FC<BookingDistributionComponentProps> = () => {

    const auth = useAuth()
    const theme = useTheme()
    const params = useParams()
    const {t, i18n} = useTranslation("examManagement")

    const [chart, setChart] = useState<any>(null)
    const [chartLarge, setChartLarge] = useState<boolean>(false)

    React.useEffect(() => {
        axios.get("/api/exam/supervision/bookingSlots/" + params.id, auth.axiosAuthHeader()).then((response) => {
            setChart(response.data)
        }, () => {
        })
    }, []);

    ChartJS.defaults.color = theme.getTheme() === "dark" ? "#fff" : "#000";
    ChartJS.defaults.borderColor = "#6c757d"
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        ChartTitle,
        ChartTooltip,
        Legend,
        Colors,
        ChartDataLabels
    );

    const options = {
        indexAxis: "y" as const,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            colors: {
                forceOverride: true,
                enabled: true
            },
            datalabels: {
                formatter: function (value: any) {
                    return value !== 0 ? value : "";
                }
            },
            tooltip: {
                callbacks: {
                    label: function (context: any) {
                        return t("distribution.tooltip", {time: context.dataset.label, count: context.raw})
                    },
                    parsed: function (context: any) {
                        return context
                    }
                }
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
                title: {
                    display: true,
                    text: t("distribution.axis.bookings")
                }
            },
            y: {
                stacked: true,
                title: {
                    display: true,
                    text: t("distribution.axis.days")
                }
            },
        },
    }
    return (<div className="component">
        <Container fluid>
            <Row>
                <Col>
                    <Card>
                        <Card.Header><h3><i className="bi-bar-chart-steps"></i> {t("distribution.title", {
                            exam: chart ? (i18n.language === "en" ? chart.exam.name_en || chart.exam.name_de : chart.exam.name_de) : "..."
                        })}</h3>
                        </Card.Header>
                        {chart ? <Card.Body style={{height: chart.labels.length * 20 + "px"}}>
                            <Bar color={"red"} className="text-white" options={options} data={{
                                labels: chart.labels.map((l: any) => moment(l).format("dd, DD.MM.YY")),
                                datasets: chart.datasets
                            }}/>
                        </Card.Body> : null}
                    </Card>
                </Col>
            </Row>
        </Container>
    </div>)
}
export default BookingDistributionComponent
